import axios from '@/axios.config';
import { ApiResponse, IPaginated, PaginationParams } from '@/types/fetch.type';
import { IInsurance } from '@/types/v2';
import { buildQueryParams } from '@/utils';
import { AxiosError } from 'axios';
import { useMutation, useQuery } from 'react-query';

export function useGetAllInsurancesPaginated({ params }: { params: PaginationParams }) {
   return useQuery<ApiResponse<IPaginated<IInsurance[]>>, AxiosError>({
      queryKey: ['allInsurances', params.page, params.limit],
      queryFn: async () => {
         const page = params.page - 1;
         const res = await axios.get(`/insurances/all/paginated?${buildQueryParams({ ...params, page })}`);
         return res.data;
      },
   });
}

export function useGetAllInsurances() {
   return useQuery<ApiResponse<IInsurance[]>, AxiosError>({
      queryKey: 'allInsurances',
      queryFn: async () => {
         const res = await axios.get('/insurances/all');
         return res.data;
      },
   });
}

export function useCreateInsurance() {
   return useMutation<
      ApiResponse<IInsurance>,
      AxiosError<{
         message: string;
      }>,
      {
         name: string;
         insuranceKey: string;
         description: string;
         apiUrl: string;
         apiKey: string;
      },
      void
   >((data) => axios.post('/insurances/create', data).then((res) => res.data));
}

export function useUpdateInsurance() {
   return useMutation<
      ApiResponse<IInsurance>,
      AxiosError<{
         message: string;
      }>,
      {
         id: string;
         body: IInsurance;
      },
      void
   >((data) => axios.put(`/insurances/update/${data.id}`, data.body).then((res) => res.data));
}

export const fetchInsurance = async (id: string): Promise<(IInsurance & { _id: string }) | null> => {
   try {
      const { data } = await axios.get(`/insurances/id/${id}`);
      if (data.success) return data.data;
      return null;
   } catch (error) {
      console.log(error);
      return null;
   }
};

export function useDeleteInsurance() {
   return useMutation<
      ApiResponse<IInsurance>,
      AxiosError<{
         message: string;
      }>,
      {
         id: string;
      },
      void
   >((data) => axios.delete(`/insurances/delete/${data.id}`).then((res) => res.data));
}
